import { useState } from 'react';
import { useHistory } from 'react-router-dom';

function getActiveTabNameFromURL(history) {
  return history.location.hash.substr(1);
}

function getInitialTab(visibleTabs, history) {
  const tabNameInURL = getActiveTabNameFromURL(history);
  const selectedTab = visibleTabs.filter(tab => tab.name === tabNameInURL);
  return selectedTab.length > 0 ? selectedTab[0] : visibleTabs[0];
}

const useActiveTab = visibleTabs => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(
    getInitialTab(visibleTabs, history)
  );

  function getTabByName(name) {
    return visibleTabs.filter(tab => tab.name === name)[0];
  }

  const handleChangeTab = (e, clickedTabName) => {
    const clickedTab = getTabByName(clickedTabName);
    setActiveTab(clickedTab);
    const { location } = history;
    const newPath = `${location.pathname}${location.search}#${clickedTabName}`;
    history.replace(newPath);
  };

  return [activeTab, setActiveTab, handleChangeTab];
};

export default useActiveTab;
